import type { IconProps } from './types';

function Edit03Icon(props: IconProps) {
  const { size = 20, color = 'currentColor', ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={ref}
    >
      <path
        d="M7.3125 17.625L18.0938 6.84375L13.4062 2.15625L2.62497 12.9375L2.62499 17.625H7.3125Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path d="M1.6875 21.375H22.3125" stroke={color} strokeWidth="1.5" />
    </svg>
  );
}

export { Edit03Icon };
